import {ToMatchOptions} from 'Shared/utilities/MapDiscriminatedUnion';
import {getEq} from 'fp-ts/lib/Array';
import {eqNumber, eqString, getStructEq} from 'fp-ts/lib/Eq';

export class UnvalidatedRegionCode {
  public readonly key = 'UnvalidatedRegionCode';

  constructor(public readonly value: string, public readonly id: number) {}
}

export class InvalidRegionCode {
  public static create(regionCode: string, id: number) {
    return regionCode === '' ? new UnvalidatedRegionCode('', id) : new InvalidRegionCode(regionCode, id);
  }

  public readonly key = 'InvalidRegionCode';

  private constructor(public readonly value: string, public readonly id: number) {}
}

export class ValidRegionCode {
  public static create(regionCode: string, id: number) {
    return regionCode.length === 2 ? new ValidRegionCode(regionCode, id) : InvalidRegionCode.create(regionCode, id);
  }

  public readonly key = 'ValidRegionCode';

  private constructor(public readonly name: string, public readonly id: number) {}
}

export type RegionCode = InvalidRegionCode | ValidRegionCode | UnvalidatedRegionCode;

type RegionCodeOptions<TReturn> = ToMatchOptions<RegionCode, 'key', TReturn>;

export const matchRegionCode = <TReturn>(agentNumber: RegionCode, options: RegionCodeOptions<TReturn>) => {
  switch (agentNumber.key) {
    case 'InvalidRegionCode':
      return options.InvalidRegionCode(agentNumber);
    case 'UnvalidatedRegionCode':
      return options.UnvalidatedRegionCode(agentNumber);
    case 'ValidRegionCode':
      return options.ValidRegionCode(agentNumber);
  }
};

export const eqRegionCode = getStructEq({
  id: eqNumber,
  name: eqString,
});

export const eqArrayOfRegionCodes = getEq(eqRegionCode);
